export default "__VITE_ASSET__DWDXyNZR__"